import { useCallback, useEffect, useRef, useState } from 'react';

const FLASH_DURATION_MS = 1500;

export const useFlashCell = () => {
  const [flashingCells, setFlashingCells] = useState<Set<string>>(new Set());
  const flashTimers = useRef<Map<string, ReturnType<typeof setTimeout>>>(
    new Map(),
  );

  useEffect(() => {
    const timers = flashTimers.current;
    return () => {
      for (const timer of timers.values()) clearTimeout(timer);
    };
  }, []);

  const flashCell = useCallback((primaryKey: string) => {
    setFlashingCells((prev) => new Set(prev).add(primaryKey));
    const existing = flashTimers.current.get(primaryKey);
    if (existing) clearTimeout(existing);
    const timer = setTimeout(() => {
      setFlashingCells((prev) => {
        const next = new Set(prev);
        next.delete(primaryKey);
        return next;
      });
      flashTimers.current.delete(primaryKey);
    }, FLASH_DURATION_MS);
    flashTimers.current.set(primaryKey, timer);
  }, []);

  return { flashingCells, flashCell };
};
